import React from 'react';
import PropTypes from 'prop-types';
import AmplifyTable from '@amplify/amplify-table';
import { ICON } from '../../../../constants/shared/CommonConstants';
import { TextCell } from '../../../../components/cell/shared/Cells';
import SelectableTableRow from '../../../../components/table/SelectableTableRow';
import './DecodeProbeDetails.scss';

const { DONE, CLOSE } = ICON;

const buildColumns = () => {
    return [
        {
            dataKey: 'response',
            label: 'Response',
            width: 100,
        },
        {
            dataKey: 'word',
            label: 'Word',
            width: 300,
        },
    ];
};

const buildRows = data => {
    const columns = ['Response', 'Word'];
    return data.map(val => {
        const rowData = {};
        if (val[0] === 'C')
            rowData[columns[0]] = (
                <TextCell
                    content={DONE}
                    classNames="cell-detail green-tick decode-cell"
                    isDataCell={false}
                />
            );
        else if (val[0] === 'NC')
            rowData[columns[0]] = (
                <TextCell
                    content={CLOSE}
                    classNames="cell-detail red-cross decode-cell"
                    isDataCell={false}
                />
            );
        else
            rowData[columns[0]] = (
                <TextCell
                    content={val[0]}
                    classNames="cell-detail decode-cell"
                    isDataCell={false}
                />
            );
        rowData[columns[1]] = (
            <TextCell content={val[1]} classNames="cell-detail decode-cell" isDataCell={false} />
        );
        return rowData;
    });
};

const renderDetails = rows => (
    <AmplifyTable
        isSortable={false}
        columns={buildColumns()}
        rows={buildRows(rows)}
        measurements={{
            headerHeight: 60,
            rowHeight: 60,
        }}
        classNames={{
            headerClassName: 'cell decode-header justify-content-between',
            rowClassName: 'decode-row',
            className: 'decode-table',
        }}
        headerRenderer={({ label }) => {
            return <span>{label}</span>;
        }}
        rowRenderer={renderProps => <SelectableTableRow {...renderProps} />}
    />
);

const DecodeProbeDetailsContent = ({ result, content }) => {
    const { score, probeMaxScore: maxScore } = result;
    const { responses } = result.itemLevelDetails;
    const { words } = content;
    const maxLength = Math.max(responses.length, words.length);
    const rowArray = Array.from({ length: maxLength }, (_, index) => [
        responses[index],
        words[index],
    ]);

    return (
        <section className="section-block">
            <div className="d-flex justify-content-between">
                <span className="decode-score">
                    Score: <b>{`${score}/${maxScore}`}</b>
                </span>
            </div>
            <div>{renderDetails(rowArray)}</div>
        </section>
    );
};

DecodeProbeDetailsContent.defaultProps = {
    result: {},
    content: {},
};

DecodeProbeDetailsContent.propTypes = {
    result: PropTypes.object,
    content: PropTypes.object,
};

export default DecodeProbeDetailsContent;
